import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { Notification } from '@core-argos-angular-artifact/components';
import {
  AuthenticationService,
  ConfigService
} from '@core-argos-angular-artifact/core';
import 'core-argos-litelement-artifact/src/unsubscribe-communications/unsubscribe-communications.js';
import { decode } from 'js-base64';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'my-account-unsubscribe-communications',
  templateUrl: './unsubscribe-communications.component.html',
  styleUrls: ['./unsubscribe-communications.component.scss']
})
export class UnsubscribeCommunicationsComponent implements OnInit {
  userEmail: string;

  key: string;
  public showCancelationRollbackText = true;
  suParam = '';
  env: string;

  buttons = {};

  validKey = true;

  logged = false;

  redirectLink: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly alertService: NotificationService,
    private readonly authService: AuthenticationService,
    private readonly configService: ConfigService
  ) {
    this.key = this.route.snapshot.queryParamMap.get('key');
    this.suParam = this.route.snapshot.queryParamMap.get('su');
    if (this.suParam && this.suParam === 'true') {
      this.showCancelationRollbackText = false;
    }
    if (this.configService.getEnv() !== 'pro') {
      this.env = this.configService.getEnv();
    }
    this.redirectLink = this.configService.getConfig()?.productUrl;
  }

  ngOnInit(): void {
    try {
      const dataKey = JSON.parse(decode(this.key));
      if (!dataKey.email) {
        throw new Error('no email');
      }
      this.userEmail = dataKey.email;
    } catch (err) {
      this.validKey = false;
      this.logged = this.authService.isAuthenticated();
    }
  }

  cancelAction(): void {
    this.redirectToUniversia();
  }

  showError(): void {
    this.alertService.showErrorNotification({
      text: _('unsubscribe-communications.error')
    } as Notification);
  }

  goTo(): void {
    this.redirectToUniversia();
  }

  redirectToUniversia(): void {
    window.location.href = this.configService.getConfig()?.productUrl;
  }
}
